import { createFileRoute } from '@tanstack/react-router';
import { ReviewRedirect } from '@/containers/sequences/clu/review-redirect.component';
import { SequencingPage } from '@/containers/sequences/sequencing-page.component';

// Drafts are reviewed inside each sequence (its Review section). The route
// stays so old links and notifications still land.
export const Route = createFileRoute('/sequences/review')({
  component: ReviewRoute,
});

function ReviewRoute() {
  return (
    <SequencingPage title='Sequences'>
      <ReviewRedirect />
    </SequencingPage>
  );
}
